import "./AppLoader.css";
import logo from "../../../assets/images/logo.png";

function AppLoader({ isFinishing }) {
  return (
    <div className={`app-loader ${isFinishing ? "app-loader--finish" : ""}`}>
      <img
        src={logo}
        alt="IRQGYP logo"
        className={`app-loader__logo ${isFinishing ? "app-loader__logo--done" : ""}`}
      />
    </div>
  );
}

export default AppLoader;
